import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Paper, Chip, } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ChevronLeft, User } from 'react-feather';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import Toastmessage from '../../components/Toast';
import { logout } from '../../features/auth/AuthSlice';
import { useSelector } from 'react-redux';
import { authApi } from '../../api/api';

export default function FirmDetails() {
    const location = useLocation();
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const userID = useSelector((state_id) => state_id.auth.id);
    const token = useSelector((state_id) => state_id.auth.token);
    const { clientId } = location.state || {};
    const [formData, setFormData] = useState({
        full_name: '',
        email: '',
        phone_number: '',
        alt_phone_number: '',
        address: '',
        city: '',
        gender:'',
        state: { id: '', state_name: '', shortCode: '' },
        country_code: '',
        zip_code: '',
        password: '',
        profile_image: '',
        confirmPassword: '',
        status: true,
    });

    useEffect(() => {
        viewClient(clientId)
    }, [clientId])

    const handleClickEdit = () => {
        navigate('/editclient', { state: { clientId: clientId } });
    };
    const handleBack = () => {
        setTimeout(() => navigate(-1), 2000);
    };

    const viewClient = async (clientId) => {
        const input_token = `${clientId}CLIENT_DETAIL`;
        const apiUrl = 'view_client_detail'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID,
            id: clientId,
        };
        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                setFormData(prevState => ({
                    ...prevState,
                    id: data.client_detail.id,
                    full_name: data.client_detail.full_name,
                    email: data.client_detail.email,
                    phone_number: data.client_detail.phone_number === "undefined" ? '' : data.client_detail.phone_number,
                    alt_phone_number: data.client_detail.alt_phone_number,
                    address: data.client_detail.address,
                    profile_image: data.client_detail.profile_image,
                    city: data.client_detail.city,
                    gender: data.client_detail.gender,
                    country_code:data.client_detail.country_code,
                    state: { id: data.client_detail.state_id, state_name: data.client_detail.state_name, }, // Assuming `state_id` corresponds to `state_name`
                    zip_code: data.client_detail.zip_code,
                    password: data.client_detail.password,
                    isActive: !!data.client_detail.status, // Convert to boolean
                }));
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    }

    return (

        <Box>

            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
                className="title_head"
            >
                {/* Left Section */}
                <Box display="flex" alignItems="center">
                    <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={12} color="var(--text-color)">
                        View Client
                    </Typography>
                </Box>

                {/* Right Section */}
                <Button
                    variant="outlined"
                    component={Link}
                    to="/client"
                    sx={{
                        backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '10px 20px'
                    }}
                    startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
                    style={{ textTransform: 'none' }}
                >
                    Back Client list
                </Button>
            </Box>



            <Box className="card-box" sx={{ p: { xs: 2, sm: 2, md: 3 }, m: { xs: 1, sm: 2, md: 3 }, border: '1px solid var(--border-color)', borderRadius: '8px' }}>
                 <Box className="sub-header">
                    <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }} >
                        View Client
                    </Typography>
                    <Typography
                        sx={{ fontWeight: 'bold' }}
                    >
                        Account status: <span sx={{ color: formData.isActive ? 'green' : 'red', backgroundColor: formData.isActive ? 'transparent' : 'red', display: 'inline-block', fontWeight: 'bold' }}>{formData.isActive ? 'Yes' : 'No'}</span>
                    </Typography>
                </Box>


                <Box >
                    <Grid container spacing={6}>
                        <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Clinet Name :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.full_name}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Clinet Email ID :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.email}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Clinet Contact Number :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.phone_number}</Typography>
                        </Grid>

                        <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Client Alternative Contact Number :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.alt_phone_number}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Gender :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.gender}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Client Address:</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.address}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Country:</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.country_code}</Typography>
                        </Grid>

                        <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>State :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.state?.state_name}</Typography>
                        </Grid>

                        <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>City :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.city}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Zip Code :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.zip_code}</Typography>
                        </Grid>

                        <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Client Photo</Typography>
                            <Box component="img" src={formData.profile_image} alt="Company Logo" sx={{ width: 100, height: 'auto' }} />
                        </Grid>

                        {/* <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Login Password</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.password}</Typography>
                        </Grid> */}
                    </Grid>


                    {/* Action Buttons */}
                    <Box display={'flex'} justifyContent={'center'} gap={2} mt={4}>
                        <Button variant="contained" color="primary" onClick={() => handleClickEdit()}
                            sx={{ padding: '15px 30px', borderRadius: "8px", fontWeight: 'bold', backgroundColor: 'var(--primary-color)', color: '#fff', '&:hover': { backgroundColor: 'var(--primary-color)' } }}

                        >Edit Client Details</Button>
                        <Button variant="outlined" onClick={() => handleBack()}
                            sx={{ padding: '15px 30px', borderRadius: "8px", fontWeight: 'bold', backgroundColor: 'var(--back-button)',
                                color: "var(--back-color)", '&:hover': { backgroundColor: 'var(--primary-color)', color: '#fff' } }}
                        ><ChevronLeft size={24} /> Back to Client list</Button>
                    </Box>
                </Box>
            </Box>

        </Box>
    );
}
